// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriveTimeToolRouteSelection.Feature {
  padding-bottom: 3rem;
}
.DriveTimeToolRouteSelection.Feature > .container-fluid {
  --bs-gutter-x: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 1.5rem;
}
.DriveTimeToolRouteSelection.Feature > .container-fluid > div {
  padding-left: 4rem;
  padding-right: 4rem;
}
.DriveTimeToolRouteSelection.Feature .RouteSelectionActions .btn {
  --bs-btn-padding-x: 1.5rem;
  --bs-btn-padding-y: 1rem;
}
.DriveTimeToolRouteSelection.Feature .btn {
  --bs-btn-padding-x: 1rem;
  --bs-btn-padding-y: 0.5rem;
}
.DriveTimeToolRouteSelection.Feature .FormField:not(.condensed) {
  margin: 0;
}
.DriveTimeToolRouteSelection.Feature .FormField .FormField-Wrapper {
  height: auto;
}
.DriveTimeToolRouteSelection.Feature .FormField .FormField-Wrapper .FormField-Input .form-check-input {
  width: 1.16rem;
  height: 1.16rem;
  margin-top: 0.15rem;
}
.DriveTimeToolRouteSelection.Feature .FormField .FormField-Wrapper .FormField-Input .form-check-input:focus {
  border-color: var(--bs-secondary);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-secondary-rgb), 0.25);
}
.DriveTimeToolRouteSelection.Feature .FormField .FormField-Wrapper .FormField-Input .form-check-input:checked {
  background-color: var(--bs-secondary);
  border: 1px solid var(--bs-secondary);
}
.DriveTimeToolRouteSelection.Feature *:not(.fa):not(.sv) > i + span {
  margin-left: inherit;
}

.pac-container {
  z-index: 1056;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/pages/RouteSelection/styles.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AAAE;EACE,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AACJ;AAAI;EACE,kBAAA;EACA,mBAAA;AAEN;AAEI;EACE,0BAAA;EACA,wBAAA;AAAN;AAIE;EACE,wBAAA;EACA,0BAAA;AAFJ;AAMI;EACE,SAAA;AAJN;AAOI;EACE,YAAA;AALN;AAQQ;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AANV;AAQU;EACE,iCAAA;EACA,6DAAA;AANZ;AAQU;EACE,qCAAA;EACA,qCAAA;AANZ;AAaE;EACE,oBAAA;AAXJ;;AAcA;EACE,aAAA;AAXF","sourcesContent":[".DriveTimeToolRouteSelection.Feature {\n  padding-bottom: 3rem;\n  > .container-fluid {\n    --bs-gutter-x: 0;\n\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    gap: 1.5rem;\n    > div {\n      padding-left: 4rem;\n      padding-right: 4rem;\n    }\n  }\n  .RouteSelectionActions {\n    .btn {\n      --bs-btn-padding-x: 1.5rem;\n      --bs-btn-padding-y: 1rem;\n    }\n  }\n\n  .btn {\n    --bs-btn-padding-x: 1rem;\n    --bs-btn-padding-y: 0.5rem;\n  }\n\n  .FormField {\n    &:not(.condensed) {\n      margin: 0;\n    }\n\n    .FormField-Wrapper {\n      height: auto;\n\n      .FormField-Input {\n        .form-check-input {\n          width: 1.16rem;\n          height: 1.16rem;\n          margin-top: 0.15rem;\n\n          &:focus {\n            border-color: var(--bs-secondary);\n            box-shadow: 0 0 0 0.25rem rgba(var(--bs-secondary-rgb), 0.25);\n          }\n          &:checked {\n            background-color: var(--bs-secondary);\n            border: 1px solid var(--bs-secondary);\n          }\n        }\n      }\n    }\n  }\n\n  *:not(.fa):not(.sv) > i + span {\n    margin-left: inherit;\n  }\n}\n.pac-container {\n  z-index: 1056; // higher than modal's 1055\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
